<script>
  import { navigate } from "svelte-routing";
  import Timeline from "./TimelineItem.svelte";
  import { Icon } from "t2c-components";

  export let item;
  export let lawcaseId;

  const handleNavigate = () => {
    const route = `/lawcase/${lawcaseId}/folder/${item.folderId}`;
    navigate(route);
  };
</script>

<Timeline {item}>
  <div class="subtitle" on:click={handleNavigate}>
    <Icon inline medium icon="folder" stroke="#999" />
    <span class="folder">{item.folderName}</span>
  </div>
  <p class="description">{item.description ? item.description : ""}</p>
</Timeline>

<style>
  .description {
    color: #999;
  }

  .subtitle {
    margin-top: 6px;
    font-size: 13px;
    color: #999;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .folder {
    margin-left: 8px;
  }
</style>
